<script setup lang="ts">
// PrintHQ Vault in the sidebar: a way to the desktop app's download, on
// printhq.io (it always offers the newest release for each system).
import { Download01Icon } from "@/components/icons";

defineProps<{ collapsed?: boolean }>();

const DOWNLOAD_URL = "https://printhq.io/#download";
</script>

<template>
	<a
		v-if="!collapsed"
		:href="DOWNLOAD_URL"
		target="_blank"
		rel="noopener noreferrer"
		class="flex items-center gap-2.5 mx-3 mb-2 p-2.5 rounded-xl border border-line bg-panel hover:border-line-strong transition-colors"
	>
		<img src="/vault-icon.png" alt="" class="size-8 rounded-lg shrink-0" />
		<span class="flex-1 min-w-0">
			<span class="block text-[13px] font-medium truncate">Get PrintHQ Vault</span>
			<span class="block text-[11px] text-fg-3 truncate">For Mac and Windows</span>
		</span>
		<Download01Icon :size="15" class="text-fg-3 shrink-0" />
	</a>
	<a
		v-else
		:href="DOWNLOAD_URL"
		target="_blank"
		rel="noopener noreferrer"
		class="mx-auto mb-2 size-8 flex items-center justify-center rounded-lg hover:bg-card-hover transition-colors"
		aria-label="Get PrintHQ Vault"
		v-tooltip.right="'Get PrintHQ Vault'"
	>
		<img src="/vault-icon.png" alt="" class="size-6 rounded-md" />
	</a>
</template>
